// extracted by mini-css-extract-plugin
module.exports = {"container":"active-board-user_container__8_ZW7","bg":"active-board-user_bg__EOC3O","followingIcon":"active-board-user_followingIcon__cydpC","cim":"active-board-user_cim__V_MfM"};